export default "__VITE_ASSET__jE6iW3oj__"